export const FIELDS = {
    MESSAGES: 'messages',
    TEXT: 'text',
    TYPE: 'type'
};
